var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" "+_vm._s(this.$t('no-warehouse-choise-made'))+" ")]),_c('warehouse-selector-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }